import { Component, Input, Output, EventEmitter, OnInit, OnChanges, OnDestroy, HostBinding } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import { SelectableCardInputType, SelectableCards } from './model/selectable-card.model';
import { SelectedCards } from './model/selected-card.model';

@Component({
  selector: 'vm-selectable-cards',
  templateUrl: './selectable-card-wrapper.component.html',
  styleUrls: ['./selectable-card-wrapper.component.scss'],
})
export class SelectableCardsWrapperComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectableCards: SelectableCards[];
  @Input() containerItemPercent: string;
  @Input() containerItemAlignment: string;
  @Input() includeModalOkButton: boolean;
  @Input() serviceCategory: string;
  @Input() includedTextVisibility = true;
  @Input() chargesTextVisibility = false;
  @Input() includeSecondaryCloseButton = false;
  @Input() imgSizeManipulation = false;
  @Output() selectedCards: EventEmitter<SelectedCards> = new EventEmitter(true);

  private subsription: Subscription;
  headingMultilineHeight: number;
  isGroupHavingToggle: boolean;
  checkboxProductMap: Map<string, boolean> = new Map();
  radioProductMap: Map<string, boolean> = new Map();
  selectedCard: SelectedCards;
  innerWidth: any;
  ngOnInit(): void {
    this.checkIfGroupLevelToggle();
    this.checkIfHeadingHasMultiLine();
    this.setDefaultRadioChecked();
    this.setDefaultCheckBoxChecked();
    this.innerWidth = window.innerWidth;
  }

  ngOnChanges(): void {
    this.checkIfGroupLevelToggle();
    this.checkIfHeadingHasMultiLine();
    this.setDefaultRadioChecked();
    this.setDefaultCheckBoxChecked();
  }

  constructor(private sanitizer: DomSanitizer) {}

  @HostBinding('attr.style')
  public get valueAsStyle(): any {
    let flexVal = 'auto';
    if (this.containerItemAlignment === 'center') {
      flexVal = 'none';
    }
    return this.sanitizer.bypassSecurityTrustStyle(
      `--content-percent: ${this.containerItemPercent}; --content-align: ${this.containerItemAlignment}; --flex-val: ${flexVal}`
    );
  }

  addSelectedToggleOption(addOnProductId: string) {
    const selectedCard = this.setSelectedProductDetails(addOnProductId, '', '', true, '', '', '');
    this.selectedCards.emit(selectedCard);
  }

  removeSelectedToggleOption(addOnProductId: string) {
    const selectedCard = this.setSelectedProductDetails(addOnProductId, '', '', false, '', '', '');
    this.selectedCards.emit(selectedCard);
  }

  selectProduct(selectableCard: SelectableCards) {
    if (event) {
      event.preventDefault();
    }
    if (selectableCard.disableSelection) {
      return;
    }
    if (
      selectableCard.isRadioOrCheckBox &&
      selectableCard.isRadioOrCheckBox === 'Radio' &&
      !selectableCard.isRadioUncheckAllowed
    ) {
      if (selectableCard.isClicked || selectableCard.isDefaultProduct) {
        return;
      } else {
        selectableCard.isClicked = true;
      }
    }

    const toggleSelectedCard = selectableCard.selectedToggleSegmentDetail;
    let addOnProduct: any;
    if (selectableCard.isToggle && toggleSelectedCard && toggleSelectedCard.selectedToggleOption === 'HD') {
      addOnProduct = {
        amount: toggleSelectedCard.amount,
        productId: toggleSelectedCard.productId,
        serviceCategory: toggleSelectedCard.serviceCategory,
        isRadioOrCheckBox: toggleSelectedCard.isRadioOrCheckBox,
      };
    }

    let selectedProduct = null;
    if (selectableCard.isRadioOrCheckBox === 'Checkbox') {
      const selectedProductId = selectableCard.productId;
      this.checkboxToggle(selectedProductId);
      if (this.checkboxProductMap.get(selectedProductId)) {
        const icon = this.getSelectableCardIcon(selectableCard.icons);
        selectedProduct = this.setSelectedProductDetails(
          selectableCard.productId,
          selectableCard.amount,
          selectableCard.tileHeading,
          true,
          icon,
          selectableCard.serviceCategory,
          selectableCard.isRadioOrCheckBox
        );
        this.selectedCard = selectedProduct;
      } else {
        const icon = this.getSelectableCardIcon(selectableCard.icons);
        selectedProduct = this.setSelectedProductDetails(
          selectableCard.productId,
          selectableCard.amount,
          selectableCard.tileHeading,
          false,
          icon,
          selectableCard.serviceCategory,
          selectableCard.isRadioOrCheckBox
        );
        this.selectedCard = selectedProduct;
      }
    } else {
      const selectedProductId = selectableCard.productId;
      this.radioToggle(selectedProductId, selectableCard.isRadioUncheckAllowed);
      if (this.radioProductMap.get(selectedProductId)) {
        const icon = this.getSelectableCardIcon(selectableCard.icons);
        selectedProduct = this.setSelectedProductDetails(
          selectableCard.productId,
          selectableCard.amount,
          selectableCard.tileHeading,
          true,
          icon,
          selectableCard.serviceCategory,
          selectableCard.isRadioOrCheckBox,
          addOnProduct
        );
        this.selectedCard = selectedProduct;
      } else {
        const icon = this.getSelectableCardIcon(selectableCard.icons);
        selectedProduct = this.setSelectedProductDetails(
          selectableCard.productId,
          selectableCard.amount,
          selectableCard.tileHeading,
          false,
          icon,
          selectableCard.serviceCategory,
          selectableCard.isRadioOrCheckBox,
          addOnProduct
        );
        this.selectedCard = selectedProduct;
      }
    }
    this.selectedCards.emit(this.selectedCard);
  }

  updateStoredCheckedState({ radioOrCheckbox, productId, isChecked }) {
    if (radioOrCheckbox === SelectableCardInputType.RADIO) {
      this.radioProductMap.set(productId, !!isChecked);
    }
    if (radioOrCheckbox === SelectableCardInputType.CHECKBOX) {
      this.checkboxProductMap.set(productId, !!isChecked);
    }
  }

  private getSelectableCardIcon(icons) {
    let icon = '';
    if (icons !== undefined) {
      icon = icons.value;
    }
    return icon;
  }

  private setSelectedProductDetails(
    productId: string,
    amount: string,
    displayValue: string,
    isChecked: boolean,
    icon?: string,
    serviceCategory?: string,
    isRadioOrCheckBox?: string,
    addOnProduct?: any
  ) {
    return new SelectedCards(
      amount,
      productId,
      displayValue,
      isChecked,
      icon,
      serviceCategory,
      isRadioOrCheckBox,
      addOnProduct
    );
  }

  private checkIfGroupLevelToggle() {
    this.isGroupHavingToggle = false;
    for (const selectedCard of this.selectableCards) {
      if (selectedCard.isToggle) {
        this.isGroupHavingToggle = true;
        break;
      }
    }
  }

  private checkIfHeadingHasMultiLine() {
    const lineHeightArray = [];
    for (const selectedCard of this.selectableCards) {
      const lineHeight = selectedCard.tileHeading.length;
      lineHeightArray.push(lineHeight);
    }
    this.headingMultilineHeight = Math.max(...lineHeightArray);
  }

  private checkboxToggle(selectedProductId: string) {
    this.checkboxProductMap.set(selectedProductId, !this.checkboxProductMap.get(selectedProductId));
  }

  private radioToggle(selectableCardProductId: string, isRadioUncheckedAllow: boolean) {
    if (this.radioProductMap.has(selectableCardProductId)) {
      this.clearCheckedKey(selectableCardProductId, this.radioProductMap);
      const isProductAlreadyChecked = this.radioProductMap.get(selectableCardProductId);
      if (isRadioUncheckedAllow) {
        this.radioProductMap.set(selectableCardProductId, !isProductAlreadyChecked);
      } else if (!isProductAlreadyChecked) {
        this.radioProductMap.set(selectableCardProductId, true);
      }
    } else {
      this.clearCheckedKey(selectableCardProductId, this.radioProductMap);
      this.radioProductMap.set(selectableCardProductId, true);
    }
  }

  private clearCheckedKey(selectableCardProductId: string, radioMap: Map<string, boolean>) {
    for (const key of radioMap.keys()) {
      if (selectableCardProductId !== key) {
        radioMap.delete(key);
      }
    }
  }

  private setDefaultRadioChecked() {
    for (const selectedCard of this.selectableCards) {
      if (selectedCard.isRadioOrCheckBox === 'Radio') {
        if (selectedCard.isDefaultProduct) {
          this.radioProductMap.set(selectedCard.productId, true);
        }
      }
    }
  }

  private setDefaultCheckBoxChecked() {
    for (const selectedCard of this.selectableCards) {
      if (selectedCard.isRadioOrCheckBox === 'Checkbox') {
        if (selectedCard.isDefaultProduct) {
          this.checkboxProductMap.set(selectedCard.productId, true);
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.subsription !== undefined) {
      this.subsription.unsubscribe();
    }
  }
}
